import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";
import ImageUpload from "../ImageFolder/ImageUpload";

import {
  createDiseaseAPI,
  createGroupAPI,
  createPackageTestAPI,
  createSubGroupAPI,
  deletePackageTest,
  deleteTestCategory,
  deleteTestSubCategory,
  listDiseaseAPI,
  listGroupAPI,
  listPackageAPI,
  listSubGroupAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updatePackageTestAPI,
  updateSubGroupAPI,
} from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import {
  categoryDDAPI,
  categoryPackageDDAPI,
  categoryTestDDAPI,
  generateFileAPI,
  groupDDAPI,
  subCategoryDDAPI,
  testDDAPI,
} from "../../api/dropdown";
import MySelect from "../../MyComp/UI/form/MySelect";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";

const PackageTest = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [totalRows, setTotalRows] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [perPage, setPerPage] = useState(25);

  const [itemPerPage, setItemPerPage] = useState(25);
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Table Columns
  const [column, setColumn] = useState([
    // {
    //   name: "Image",
    //   selector: (row) => (
    //     <div  >
    //       {/* <img
    //         style={{ width: "50px", height: "50px", borderRadius: "6px" }}
    //         src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
    //       /> */}
    //        <UserAvatarCell row={row} name={row?.name} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>

    //     </div>
    //   ),
    //   sortable: false,
    //   wrap: true,
    // },
    //  {
    //   name: "   Package Name",
    //   selector: (row) => row?.package_name,
    //   sortable: true,
    // },
    {
      name: "Package Name",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullName = row?.package_name || "";

        return (
          <div
            title={fullName} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullName, 14)}
          </div>
        );
      },
    },
    //   {
    //   name: "Test  ",
    //   selector: (row) => row?.TestName|| "-",
    //   sortable: true,
    // wrap:true
    // },
    {
      name: "Test",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullName = row?.TestName || "";

        return (
          <div
            title={fullName} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullName, 14)}
          </div>
        );
      },
    },
    {
      name: "Group  ",
      selector: (row) => row?.category || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Sub Group  ",
      selector: (row) => row?.subCategory || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
    setValue("isLoading", true);

    deletePackageTest({ id: watch("selectedRow").id })
      .then((res) => {
        setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Fetch group list
  useEffect(() => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
      // labId:labId
    };
    getPackageList(body);
  }, []);
  const getPackageList = async (body) => {
    try {
      setValue("isLoading", true);

      const res = await listPackageAPI(body);

      if (res?.data?.status === true) {
        console.log(res?.data?.data, " res?.data?.data");
        const list = res?.data?.data?.tests || [];
        const total = res?.data?.data?.total || 0;
        setTableData(res?.data?.data?.data);
        setTotalRows(res?.data?.data?.total);
        setValue("limit", res?.data?.data?.total);
        setValue("data", list);
        setTotalRows(total); // 👈 set total count
      } else if (res?.data?.status === "expired") {
        setTableData([]);
        logout();
      } else {
        setValue("data", []);
        setTotalRows(0);
        toast.error(res?.data?.message);
      }
    } catch (err) {
      setValue("data", []);
      setTotalRows(0);
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };

  // const getPackageList = async () => {
  //   try {
  //     const res = await listPackageAPI();
  //     if (res.data.status === "expired") {
  //       toast.error(res.data.message);
  //       toast.clearWaitingQueue();
  //     } else if (res.data.status === true) {
  //       setValue("data", res.data.data);
  //     } else {
  //       setValue("data", []);
  //       toast.error(res.data.message);
  //     }
  //   } catch (err) {
  //     toast.error(err?.response?.data?.message);
  //   } finally {
  //     setValue("isLoading", false);
  //   }
  // };

  const onFormSubmit = async (data) => {
    try {
      setValue("isLoading", true);

      const bodyData = {
        package_id: data?.package?.value,
        categoryId: data?.category?.value,
        subcategoryId: data?.subcategory?.value,
        test_id: data?.test?.value,
        status: data?.status?.value,
      };

      if (mode === "Edit") {
        bodyData.id = watch("selectedRow")?.id;
      }

      const res = mode === "Add" ? await createPackageTestAPI(bodyData) : await updatePackageTestAPI(bodyData);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        await getPackageList();
        resetF();

        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };

  const handleEdit = async (row) => {
    window.scrollTo(0, 0);

    setMode("Edit");
    setIsOpen(true);
    setValue("selectedRow", row);

    setValue("package", {
      label: row.package_name,
      value: row.package_id,
    });

    setValue("category", {
      label: row.category,
      value: row.categoryId,
    });

    await getSubCategory(row.categoryId);

    setValue("subcategory", {
      label: row.subCategory,
      value: row.subcategoryId,
    });

    await getTest(row.categoryId, row.subcategoryId);

    setValue("test", {
      label: row.TestName,
      value: row.test_id,
    });

    // 5️⃣ Status
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  useEffect(() => {
    getPackage();
  }, [mode]);
  const getPackage = () => {
    setValue("isLoading", true);
    categoryPackageDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("packageDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("packageDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const resetF = () => {
    setValue("subcategory", null);
    setValue("package", null);
    setValue("test", null);
    setValue("category", null);
    setValue("status", null);
    setValue("addSub", false);
    setValue("group_img", null);
    clearErrors();
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const categoryId = watch("category")?.value;
    const subCategoryId = watch("subcategory")?.value;

    if (categoryId) {
      getSubCategory(categoryId);
    } else {
      setValue("subCategoryDD", []);
    }

    if (categoryId && subCategoryId) {
      getTest(categoryId, subCategoryId);
    } else {
      setValue("testDD", []);
    }
  }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    setValue("test", null);
  }, [watch("category"), watch("subcategory")]);
  useEffect(() => {
    setValue("subcategory", null);
  }, [watch("category")]);
  const getTest = (categoryId, subCategoryId) => {
    const body = {
      categoryId,
      subCategoryId,
    };

    testDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("testDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          setValue("testDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const getSubCategory = (categoryId) => {
    const body = { categoryId };

    subCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  const generateFile = () => {
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data, "res.fileee");
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
      // labId:labId
    };
    setLoading(true);
    getPackageList(body)
      .then((res) => {
        const status = res.data.status;
        console.log(res, "resss");
        if (status === true) {
          setLoading(false);
          console.log("limit", res?.data?.data?.totalRecords);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.labs);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };

  return (
    <>
      <Head title="Test Package | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Test Package
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className={"me-2"}>
              <div className="me-2 d-flex g-5">
                {/* <Button
                color="primary"
                outline
                className="me-n1 me-2 pe-2"
                onClick={() => {
                 generateFile()
                  resetF();
                }}
              >
                <Icon name={"file"} />
              </Button> */}
                <Button
                  color="primary"
                  outline
                  className="me-n1  mx-2"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"package"}
                      name={"package"}
                      placeholder={"Select package"}
                      required
                      options={watch("packageDD")}
                      // multi
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Group"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Group"}
                      name={"subcategory"}
                      placeholder={"Select Sub Group"}
                      required
                      options={watch("subCategoryDD")}
                      // multi
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Test"}
                      name={"test"}
                      placeholder={"Select test"}
                      required
                      options={watch("testDD")}
                      // multi
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Sub Group Name"
                      name="name"
                      placeholder="Enter group name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}

                  {/* <Col md="3">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Sub Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      setError={setError}
                      getValues={getValues}
                    />
                  </Col> */}

                  <Col md="3">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}
          <ApiPaginationDataTable
            columns={column}
            data={tableData}
            title={"Test Package"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            // generateFile={generateFile}
            resetF={resetF}
          />
          {/* <MyDataTable data={data || []} columns={column} title=" Test Package  List" isLoading={isLoading} generateFile={generateFile} resetF={resetF} /> */}
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default PackageTest;
